/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcement_PostInputs */



/**
* | output |
* | --- |
* | "Post" |
*
* @param {Announcement_PostInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const announcement_post = /** @type {((inputs?: Announcement_PostInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcement_PostInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Publicar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica")
	return /** @type {LocalizedString} */ ("Post")
});